import React from 'react';
import { Select, SelectItem } from '@carbon/react';

export interface PeriodSelectorProps {
  value: string;
  onChange: (value: string) => void;
  id?: string;
  labelText?: string;
  size?: 'sm' | 'md' | 'lg';
  hideLabel?: boolean;
  className?: string;
}

const PERIOD_OPTIONS = [
  { value: '7', label: '7 derniers jours' },
  { value: '30', label: '30 derniers jours' },
  { value: '90', label: '90 derniers jours' },
  { value: '365', label: '1 an' },
] as const;

export function PeriodSelector({
  value,
  onChange,
  id = 'period-selector',
  labelText = 'Période',
  size = 'md',
  hideLabel = false,
  className,
}: PeriodSelectorProps) {
  return (
    <Select
      id={id}
      labelText={labelText}
      hideLabel={hideLabel}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      size={size}
      className={className}
    >
      {PERIOD_OPTIONS.map((option) => (
        <SelectItem key={option.value} value={option.value} text={option.label} />
      ))}
    </Select>
  );
}
